<template>
  <div class="ad-page">
    <HpsfirProPageHeader
      title="设备管理底部"
      title-en="DEVICE BOTTOM"
      description="配置设备管理页面底部广告内容。"
    />
    <div class="ad-page__content">
      <Advertising position="devicebottom"/>
    </div>
  </div>
</template>
<script lang="ts" setup>
import Advertising from '@/components/Advertising.vue';
</script>
<style lang="scss" scoped>
.ad-page {
  display: flex;
  flex-direction: column;
  gap: 16px;

  &__content {
    padding: 0 16px 16px;
  }

  @media (max-width: 767px) {
    gap: 12px;

    &__content {
      padding: 0 8px 12px;
    }
  }
}
</style>
